
















































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import $ from 'jquery';

@Component({
  components: {
  },
})
export default class PdfViewer extends Vue {
  @Prop({required: true, default: ''})
  public url!: string;

  @Prop({required: false, default: 500})
  public height!: number;

  private pdfDoc: any = null;
  private canvas: any = null;
  private ctx: any = null;
  private scale: number = 1.5;
  private numPage: number = 1;
  private pages: number = 1;

  private loading: boolean = true;

  private mounted() {
        try {
            if (!this.isIOS) {
                return;
            }
            const self = this;
            const pdfjsLib = (window as any)['pdfjs-dist/build/pdf']; // tslint-disable-line eslint-disable-line
            pdfjsLib.GlobalWorkerOptions.workerSrc = '/js/pdf.worker.js';
            const loadingTask = pdfjsLib.getDocument(this.url);
            this.canvas = document.querySelector('#pdfCanvas');
            this.ctx = this.canvas.getContext('2d');
            this.scale = 0;
            this.numPage = 1;

            if (!loadingTask) {
                return;
            }

            loadingTask.promise.then((doc: any) => {
                self.loading = false;
                this.pdfDoc = doc;
                this.pages = doc.numPages;
                this.GeneratePDF();
            });
        } catch {
            alert('failed');
        }
    }

    private GeneratePDF() {
        this.loading = false;
        this.pdfDoc.getPage(this.numPage).then((page: any) => {

            if (this.scale === 0) {
                this.scale = 1;
                const testViewPort = page.getViewport({ scale: this.scale });
                const parentWidth = $('#pdfControls').width();
                if (parentWidth) {
                    this.scale = parentWidth / testViewPort.width;
                }
            }

            const viewport = page.getViewport({ scale: this.scale });
            this.canvas.height = viewport.height;
            this.canvas.width = viewport.width;

            const renderContext = {
                canvasContext : this.ctx,
                viewport,
            };

            page.render(renderContext);
        });
    }

    private prev() {
        if (this.numPage === 1) {
            return;
        }
        this.numPage--;
        this.GeneratePDF();
    }

    private next() {
        if (this.numPage >= this.pdfDoc.numPages) {
            return;
        }
        this.numPage++;
        this.GeneratePDF();
    }

    get isIOS() {
        return (/iPad|iPhone|iPod/.test(navigator.platform) ||
            (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1));
    }
}
